<template>
  <div>
    <Row>
      <Col :xs="24" :sm="24" :md="18" :lg="14">
        <Form
          ref="form"
          :model="forms"
          :label-width="150"
          :disabled="action == 'view' ? true : false"
        >
          <form-body
            :forms="forms"
            :items="items"
            :disabled="action == 'view' ? true : false"
          ></form-body>

          <button-box v-if="action != 'view'">
            <Poptip
              confirm
              title="请检查数据, 再确认提交"
              @on-ok="handleSubmit"
            >
              <button-sub :loading="sloading">保存</button-sub>
            </Poptip>
            <!-- <button @click="handleSubmitKnow" class="knowledge">
            保存并转存知识库
          </button> -->
          </button-box>
        </Form>
      </Col>
    </Row>
    <Modal title="图片预览" v-model="imgVisible">
      <img :src="imgUrl" style="width: 100%" />
    </Modal>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "./question.vue";

export default {
  extends: baseEdit,
  components: {
    change: Change,
  },
  props: {
    workId: {
      type: String,
      value: "",
    },
    typeId: {
      type: String,
      value: "",
    },
    state: {
      type: String,
      value: "",
    },
    handleType: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "editPro",
      key: "id",
      ll: [],
      url: {
        // get: "/admin/system/work",
        // add: "/admin/system/work",
        // edit: "/admin/system/work",
      },
      items: [
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
          rules: [{ required: false, trigger: "blur" }],
          onAddress: this.addres,
          onCancel: this.cancel,
        },

        {
          label: "收货时间",
          name: "receiveTime",
          value: "",
          // options: {
          //   disabledDate(date) {
          //     return date && date.valueOf() < Date.now() - 86400000;
          //   },
          // },
          type: "datetime",
          format: "yyyy-MM-dd HH:mm:ss",
          width: "400px",
          rules: [{ required: true, trigger: "change" }],
        },
        {
          label: "送回时间",
          name: "returnTime",
          value: "",
          // options: {
          //   disabledDate(date) {
          //     return date && date.valueOf() < Date.now() - 86400000;
          //   },
          // },
          type: "datetime",
          format: "yyyy-MM-dd HH:mm:ss",
          width: "400px",
          rules: [{ required: true, trigger: "change" }],
        },
        {
          label: "产生费用",
          name: "expensesIncurred",
          value: 0,
          type: "input",
          width: "400px",
        },
      ],
      forms: {},
    };
  },
  created() {
    // if (this.state == 3) {
    //   this.items[this.getItemIndex("state")].type = "kong";
    // }
    // this.loadWorkCommon();
    // this.loadTypeData();
    // this.$nextTick(()=>{
    //     this.forms.
    // })
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  methods: {
    handleSubmit() {
      let q = this.forms;
      q.workId = this.workId;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/work/endSuspensionWork`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$Modal.remove();
                $utils.url.push({
                  name: "completed_list",
                  path: "completed_list",
                });
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onTextChange(val) {},
    onTextFocus() {},
    onTextExtClick(v) {
      let _this = this;
      if (v.name === "maintainerContent") {
        this.$refs.change[0].loadData(2);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText2 = (val) => {
            _this.forms.maintainerContent += val + "";
          };
        }
      } else if (v.name === "teackRemark") {
        this.$refs.change[0].loadData(3);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText3 = (val) => {
            _this.forms.teackRemark += val + "";
          };
        }
      }
    },
  },
};
</script>

<style lang="less">
.workcolor {
  margin: 5px 5px 5px 150px;
  width: 80px;
  height: 30px;
}

.knowledge {
  width: 125px;
  height: 30px;
  background-color: #1890ff;
  color: #f6f8f7;
  border: none;
  cursor: pointer;
}

.completecolor {
  width: 80px;
  height: 30px;
  margin: 5px 5px 5px 30px;
}
</style>
